package com.bikompanion.data

import kotlinx.serialization.Serializable

@Serializable
data class CityBikesNetworksResponse(
    val networks: List<CityBikesNetworkDto>,
)
